module.exports = __webpack_public_path__ + "resources/img/img_dvision1_m.9eaef78556c8ede880a5c282c3217347.png";